<template lang="html">
  <div :tabindex="tabIndex" @click="clicked" @keypress="clicked" class="icon-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="#ffffff" fill-rule="evenodd">
        <path fill="#FFF" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8z"/>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      tabIndex: {
        required: false,
        type: Number,
        default: 0,
      },
    },
    methods: {
      clicked() {
        this.$emit('clicked');
      },
    },
  };
</script>

<style lang="scss" scoped>


  .icon-container {
    border-radius: 20px;
    cursor: pointer;
    height: 24px;
    width: 24px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/lib/rare-patternlab/src/components/icons/navigation/RareBackIcon.vue